import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import AddCircle from 'mdi-react/AddCircleIcon';
import Search from 'mdi-react/SearchIcon';
import HighlightOff from 'mdi-react/HighlightOffIcon';
import { DefaultRecordType } from 'rc-table/lib/interface';
import { useModal } from '../../../shared/hooks';
import { getBlackListRequest } from '../../../security/reports/ReportSpecialList/actions';
import { RootState } from '../../../../rootReducer';
import { useGridState } from '../../../shared/DataGrid/hooks/useGridState';
import { defaultGridState } from '../../../common/constants';
import { GetTripColumnsNames, MIN_FILTER_VALUE_LENGTH } from '../../../security/containers/TripsTabContainer/constants';
import { DataGrid, DataGridColumn, FilterOperators, LogicTypes } from '../../../shared/DataGrid';
import { Filter, GridFilter } from '../../../shared/DataGrid/utils/interfaces';
import styles from '../../../security/containers/TripsTabContainer/TripsTab.module.scss';
import classes from '../../../security/reports/ReportSpecialList/ReportSpecialList.module.scss';
import { RoleCell } from '../../../security/reports/ReportSpecialList/RoleCell';
import AddToBlackList from '../../../shared/AddToBlackList';
import EditBlackListModal from '../../../shared/EditBlackListModal';

const BlackList = () => {
  const [filterInputValue, setFilterInputValue] = useState('');
  const dispatch = useDispatch();
  const filterInputRef = useRef<HTMLInputElement>(null);
  const { isShow: isShowBLModal, openModal: openModalBLModal, closeModal: closeModalBLModal } = useModal();
  const { isShow: isShowEditBLModal, openModal: openEditModalBLModal, closeModal: closeEditModalBLModal } = useModal();

  const [modalData, setModalData] = useState<any>({});

  useEffect(() => {
    dispatch(getBlackListRequest());
  }, []);

  const reports = useSelector(
    (state: RootState) => state.securityModuleReducer.reportsReducer.BlackListReducer.reports,
  );

  const gridState = useGridState(reports, defaultGridState);

  useEffect(() => {
    if (filterInputValue.length < MIN_FILTER_VALUE_LENGTH) {
      gridState.setFilter({
        logic: LogicTypes.and,
        filters: [],
      });
    } else {
      const fieldsNames = Object.keys(GetTripColumnsNames(true));
      const newFilter = {
        logic: LogicTypes.or,
        filters: fieldsNames.map(
          (name): Filter => ({
            operator: FilterOperators.contains,
            value: filterInputValue,
            field: name,
          }),
        ),
      } as GridFilter;
      gridState.setFilter(newFilter);
    }
  }, [filterInputValue]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterInputValue(e.target.value);
  };

  const handleClearIconClick = () => {
    setFilterInputValue('');
    if (filterInputRef.current) {
      filterInputRef.current.focus();
    }
  };

  const onRow = (rowData: DefaultRecordType) => ({
    onDoubleClick: () => {
      setModalData(rowData);
      return openEditModalBLModal();
    },
  });

  return (
    <React.Fragment>
      <Container fluid className={classes.filterContainer}>
        <Row>
          <Col className="d-flex align-items-center">
            <Button variant="light" className={classes.add} onClick={() => openModalBLModal()}>
              &nbsp;
              <AddCircle className={styles.plusIcon} /> Додати&nbsp;
            </Button>
            <InputGroup className={classes.filter}>
              <Form.Control
                as="input"
                type="text"
                name="filter"
                onChange={handleFilterChange}
                value={filterInputValue}
                ref={filterInputRef}
              />
              <Search size={18} className={classes.searchIcon} />
              {!!filterInputValue && (
                <HighlightOff size={18} className={classes.clearFilterIcon} onClick={handleClearIconClick} />
              )}
            </InputGroup>
          </Col>
        </Row>
      </Container>
      <DataGrid
        pageable
        data={gridState.gridData}
        sort={gridState.sort}
        total={gridState.total}
        skip={gridState.pagination?.skip}
        pageSize={gridState.pagination?.pageSize}
        onPageChange={gridState.handlePageChange}
        onSortChange={gridState.handleSortChange}
        onRow={onRow}
      >
        <DataGridColumn title="ПІБ/Назва" dataIndex="description" key="description" width="10%" />
        <DataGridColumn title="Роль" dataIndex="role" key="role" width="10%" render={RoleCell} />
        <DataGridColumn title="Номер" dataIndex="number" key="number" width="5%" />
        <DataGridColumn title="Коментар" dataIndex="comment" key="comment" width="10%" />
      </DataGrid>

      <AddToBlackList show={isShowBLModal} closeHandler={closeModalBLModal} />
      <EditBlackListModal
        show={isShowEditBLModal}
        modalData={modalData}
        setModalData={setModalData}
        closeHandler={closeEditModalBLModal}
      />
    </React.Fragment>
  );
};

export default BlackList;
